<!-- Two carry-overs from the legacy renderer (`shared/grid/controls/amount-renderer/`), which this
     one had dropped.

     `color-red` on negatives is OPT-IN, via `headerComponentParams.colorNegative`: turning it on for
     everyone would change how credit notes and refunds look on grids that never asked for it.

     `ngbPopover` is reconnected - the `<em>` kept its `triggers` but had lost the popover itself, so
     `buttonTooltip` could never show. That branch needs `headerComponentParams.displayOnlyIcon`,
     which nothing sets, so it is provably inert; it is fixed so the component is whole rather than
     quietly half-wired. `NgbPopoverModule` arrives via SharedModule, already imported here.

     The legacy `grid-amount-renderer` class is deliberately NOT re-added: `_ag-grid.scss` gives it and
     the host `amount-cell` element the identical rule, so it would be redundant. -->
@if(removeComma) {
<span [hidden]="!displayAmount" [ngClass]="{ 'color-red': colorNegative && amount && amount < 0 }"> {{ amount | number: "1.2-2" | noComma }}</span>
} @else {
<span [hidden]="!displayAmount" [ngClass]="{ 'color-red': colorNegative && amount && amount < 0 }"> {{ amount | number: "1.2-2" }}</span>
}

<em [ngClass]="buttonClass" [ngbPopover]="htmlContent" triggers="mouseenter:mouseleave" container="body"></em>

<ng-template #htmlContent>
    <div class="popoverCustomWidth">
        <p>
            {{ buttonTooltip | translate }}
        </p>
    </div>
</ng-template>
